import {
  GET_LIST_NHANVAY,
  GET_LIST_NHANVAY_SUCCESS,
  GET_LIST_NHANVAY_FAILURE,
  UPDATE_SEARCHDATA_NHANVAY,
} from "./actionTypes";

export const getListNhanVay = (dataSearch) => ({
  type: GET_LIST_NHANVAY,
  dataSearch,
});

export const getListNhanVaySuccess = (data) => ({
  type: GET_LIST_NHANVAY_SUCCESS,
  payload: data,
});

export const getListNhanVayFailure = () => ({
  type: GET_LIST_NHANVAY_FAILURE,
});

export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHDATA_NHANVAY,
  payload: data,
});
